import { useMutation } from "@tanstack/react-query";
import { useFormSuccessNotification, useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import type { UpdateShopOverrideRuleDto, ShopOverrideRuleDto } from "../generated/schema";

interface UseUpdateShopOverrideRulesParams {
	onSuccess?: (data: ShopOverrideRuleDto[]) => void;
}

export default function useUpdateShopOverrideRules(
	shopId: string,
	options?: UseUpdateShopOverrideRulesParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	const mutation = $api.useMutation("patch", "/shops/{shopId}/override-rules");

	return useMutation({
		onSuccess: (data) => {
			successNotification();
			return options?.onSuccess?.(data);
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async (requestBody: UpdateShopOverrideRuleDto[]) => {
			return mutation.mutateAsync({
				params: { path: { shopId } },
				body: requestBody,
			});
		},
	});
}